import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.addBordersToGroupChanges();
  }

  addBordersToGroupChanges() {
    // Récupère tous les <th> qui ont un header-group
    const headers = this.element.querySelectorAll("th[data-header-group]");

    headers.forEach((header, index) => {
      // Ignore le premier header
      if (index === 0) return;

      const currentGroup = header.dataset.headerGroup;
      const previousGroup = headers[index - 1].dataset.headerGroup;

      // Si on change de groupe ET que le groupe actuel n'est pas vide
      if (currentGroup && currentGroup !== previousGroup) {
        header.classList.add("border-l", "border-gray-300");
      }
    });
  }
}
